import { render, staticRenderFns } from "./classifiersCreateForm.vue?vue&type=template&id=2643251c&scoped=true&"
import script from "./classifiersCreateForm.vue?vue&type=script&lang=js&"
export * from "./classifiersCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2643251c",
  null
  
)

export default component.exports